import React from 'react'
import classNames from 'classnames'
import { GxIcon } from '@garpix/garpix-web-components-react'
import {
  championshipStar,
  championshipTrophy,
  championshipWaiting
} from '@/images'
import style from './styles/championship.module.scss'
import { Link } from 'react-router-dom'
import Button from '../Button'
import Tag from '../Tag'
import { IChampionship } from '@/interfaces/Championship'
import useGame from '@/hooks/useGame'
import { useModal, usePage } from '@/hooks'
import AgeTag from '../Tag/AgeTag'

interface IProps {
  championship: IChampionship
}

const ChampionshipCatalogCard = ({
  championship
}: IProps): React.ReactElement => {
  const page = usePage()
  const { openModal } = useModal()

  const {
    id,
    property_is_finished_value: finished,
    property_tourney_register_closed_value: registerClosed,
    property_jeka_version_value: version,
    property_tournament_code_value: tournamentCodeValue,
    property_tourney_code_value: tourneyCode,
    property_age_group_value: age
  } = championship

  const handleOpenModal = (): void => {
    openModal('championshipCode', {
      tourneyCode
    })
  }

  const gameInfo = useGame(version)

  const isFinish = Boolean(Number(finished))
  const isWaiting = Boolean(Number(registerClosed)) && !isFinish
  const isOpen = !isWaiting && !isFinish
  const isShowCode = tournamentCodeValue === 'Y'

  const slicededDateCreate =
    championship.date_create !== null
      ? championship.date_create.slice(0, 10)
      : ''

  const link = page.init_state.global.config.championship_detail

  return (
    <div className={style.catalog}>
      <Link
        to={`${link}?element_id=${id}`}
        className={classNames({
          [style.catalog__link]: true,
          [style['catalog__link--code']]: isOpen
        })}
      >
        <div
          className={classNames({
            [style.catalog_status]: true,
            [style.catalog_status__open]: isOpen,
            [style.catalog_status__completed]: isFinish,
            [style.catalog_status__waiting]: isWaiting
          })}
        >
          <span className={style.catalog_status__text}>
            {isOpen
              ? (
                <>
                  <GxIcon
                    src={championshipStar}
                    className={style.catalog_status__icon}
                  />
                  Открыт набор
                </>
                )
              : (
                  ''
                )}
            {isFinish
              ? (
                <>
                  <GxIcon
                    src={championshipTrophy}
                    className={style.catalog_status__icon}
                  />
                  Завершен
                </>
                )
              : (
                  ''
                )}
            {isWaiting
              ? (
                <>
                  <GxIcon
                    src={championshipWaiting}
                    className={style.catalog_status__icon}
                  />
                  Ожидание завершения
                </>
                )
              : (
                  ''
                )}
          </span>
        </div>

        <p className={style.catalog__title}>{championship.name}</p>

        <ul className={style.catalog_tags}>
          {gameInfo !== undefined
            ? (
              <li className={style.catalog_tags__item}>
                <Tag title={gameInfo.name} />
              </li>
              )
            : (
                ''
              )}
          {age !== null
            ? (
              <li className={style.catalog_tags__item}>
                <AgeTag age={age} />
              </li>
              )
            : (
                ''
              )}
        </ul>

        {isFinish
          ? (
            <span className={style.catalog__date}>{slicededDateCreate}</span>
            )
          : (
              ''
            )}
      </Link>

      {isOpen && isShowCode
        ? (
          <Button
            wide
            highlight
            corner
            size='large'
            onClick={handleOpenModal}
            className={style.catalog__code}
          >
            Получить код
          </Button>
          )
        : (
            ''
          )}
    </div>
  )
}

export default ChampionshipCatalogCard
